import React from 'react';
import './RodoCheckbox.css';

const RodoCheckbox = ({ checked, onChange }) => {
  return (
    <div className="rodo-checkbox">
      <label>
        <input type="checkbox" checked={checked} onChange={onChange} required />
        <span>
          Wyrażam zgodę na przetwarzanie moich danych osobowych (imię, e-mail,
          treść wiadomości) w celu udzielenia odpowiedzi na wiadomość kontaktową
          zgodnie z{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Polityką prywatności
          </a>
          .
        </span>
      </label>
    </div>
  );
};

export default RodoCheckbox;
